import axiosInstance from "../../utils/config/config";

export const getAllDocuments = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllDocumentsRequest",
    });
    const { data } = await axiosInstance.get(`/document/getAllDocuments`);
    dispatch({
      type: "getAllDocumentsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllDocumentsFailure",
      payload: true,
    });
  }
};
